import { ReactNode } from 'react';
import { ReactComponent as Star } from '@packages/shared/assets/star.svg';
import { Expert, getExpertTotalReviewCount } from '@packages/shared/core/experts/entities';
import styles from './ExpertCardReviews.module.scss';

export type ExpertCardReviewsProps = {
  expert: Expert;
  icon?: ReactNode;
};

export const ExpertCardReviews = ({ expert, icon }: ExpertCardReviewsProps) => {
  const renderIcon = () => {
    if (icon) {
      return icon;
    }
    return <Star className={styles.star} />;
  };

  return (
    <>
      <div className={styles.title}>
        {expert.rating}

        {renderIcon()}
      </div>

      <span className={styles.text}>{getExpertTotalReviewCount(expert)} reviews</span>
    </>
  );
};

export default ExpertCardReviews;
